import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, CalendarDays, Users, } from "lucide-react";
import InnerLoader from "../../../../../component/ui/loader/inner-loader";
import { Table, TableBody, TableCard, TableCell, TableDepartmentTag, TableHead, TableHeaderWrap, TableRow } from "../../../../../component/table/table-layout";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import DataNotFound from "../../../../../component/ui/loader/data-not-found";
import { Link } from "react-router";
import moment from "moment";
import StatusChip from "../../../../../component/ui/chip/status";
import { KPI } from "../../../../../component/ui/layout";
import { openFancybox } from "../../../../../utils/openFancybox";

export default function PurchaseInvoicePopup({ open = true, onClose = () => { }, data }) {
    const [isLoading, setIsLoading] = useState(true);
    const apiCall = useApiCall();

    const [lists, setList] = useState([]);
    const [tableHeaders, setTableHeaders] = useState([]);

    useEffect(() => {
        getData();
        console.log("DATA", data)
    }, []);

    const getData = async () => {
        setIsLoading(true);
        let extraUrl = `?invoice_id=${data?.id}`;

        try {
            const res = await apiCall({ method: "get", url: `get-purchase-list${extraUrl}` });
            setList(res.data);
            setTableHeaders(res.headers);
            setIsLoading(false);
        } catch (error) {
            console.warn("Error : ", error);
        }
    };

    useEffect(() => {
        function onKey(e) {
            if (e.key === "Escape") onClose();
        }
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    const hiddenCols = [
        "invoice_path",
        "status",
        "notes",
        "vendor_name"
    ]

    return (
        <AnimatePresence>
            {open && (
                <motion.div
                    className="fixed inset-0 z-[60] flex items-stretch justify-end bg-slate-900/40 backdrop-blur-sm"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                >
                    <motion.aside
                        initial={{ x: 40, opacity: 0 }}
                        animate={{ x: 0, opacity: 1 }}
                        exit={{ x: 40, opacity: 0 }}
                        transition={{ type: "spring", stiffness: 380, damping: 32 }}
                        className={`
                            relative mt-auto mr-[2vh] mb-auto ml-0 flex flex-col h-[98vw] max-h-[96vh] w-[750px] max-w-[98vw] overflow-hidden rounded-xl border border-solid border-slate-200 bg-gradient-to-b from-white to-slate-50 shadow-xl !p-0
                        `}
                        aria-modal
                        role="dialog"
                    >
                        {/* Header */}
                        <div className="border-b border-solid border-slate-200 bg-white/90 p-3 backdrop-blur supports-[backdrop-filter]:bg-white/70 w-full">
                            <div className="flex items-start justify-between gap-2 w-full">
                                <div className="flex gap-4 items-start">
                                    <h3 className="flex flex-col items-start gap-1">
                                        <span className="font-semibold text-gray-900 text-xl leading-[1.1]">{data?.vendor_name}</span>
                                        {/* <span className="font-bold text-gray-700 text-xl leading-[1.1]">({data?.total_amount})</span> */}
                                        <TableDepartmentTag>{data?.location_name}</TableDepartmentTag>
                                    </h3>
                                    <StatusChip color={data?.status == "paid" ? "green" : "red"}>{data?.status}</StatusChip>
                                </div>

                                <div className="flex flex-shrink-0 items-center gap-2">
                                    {/* {data?.invoice_path ?
                                        <Link to={data?.invoice_path} target="_blank"
                                            className="inline-flex cursor-pointer items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                                            // onClick={() => {setShowModal(true)}}
                                        >
                                            View Invoice
                                        </Link>
                                        :
                                        null
                                    } */}
                                    {data?.invoice_path ?
                                        <div
                                            onClick={() => openFancybox(data?.invoice_path)}
                                            className="inline-flex cursor-pointer items-center gap-1.5 rounded-xl border border-solid border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 hover:bg-slate-50"
                                        >
                                            View Invoice
                                        </div>
                                        :
                                        null
                                    }
                                    <button
                                        className="inline-flex items-center gap-1.5 rounded-lg bg-[#0B54FF] px-3 py-2 text-sm font-medium text-white hover:bg-[#0849e0]"
                                        onClick={onClose}
                                        aria-label="Close"
                                    >
                                        <X className="size-4" /> Exit
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* Body */}
                        <div className="w-full h-full overflow-hidden p-3">

                            {isLoading ? (
                                <InnerLoader />
                            ) : !lists?.length ? (
                                <DataNotFound title={"Data"} />
                            ) : (
                                <>
                                    <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-2">
                                        <KPI
                                            // icon={Users}
                                            label={"Vendor Name"}
                                            size="small"
                                            // extraClass={"theme"}
                                            value={data?.vendor_name}
                                        />

                                        <KPI
                                            // className={"h-full flex flex-col justify-between"}
                                            // icon={Users}
                                            label={"Invoice Month"}
                                            // extraClass={"theme"}
                                            value={data?.invoice_month ? moment(data?.invoice_month, "MM-YYYY").format("MMM YYYY") : "-"}
                                            size="small"
                                        //   sublabel={`Previous Month: ${dashboardData?.kpi_cards?.total_ad_spend?.last}`}
                                        //   stateLable={`${dashboardData?.kpi_cards?.total_ad_spend?.mom_change?.replace("-", "")}`}
                                        //   positive={!dashboardData?.kpi_cards?.total_ad_spend?.mom_change.includes("-")}                     
                                        />

                                        <KPI
                                            // icon={Users}
                                            label={"Total Amount"}
                                            size="small"
                                            // extraClass={"theme"}
                                            value={data?.total_amount}
                                        />
                                    </div>
                                    <TableCard className={`!h-[calc(100%-105px)]`}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell header sticky>
                                                        <div className="flex gap-4 items-center">
                                                            <span>Date</span>
                                                        </div>
                                                    </TableCell>
                                                    {tableHeaders?.map((eachHead, index) =>
                                                        eachHead.is_visible === 1 && eachHead?.show == 1 && !hiddenCols.includes(eachHead?.key) ? (
                                                            <TableCell header key={index}>
                                                                <TableHeaderWrap>
                                                                    <span>{eachHead?.value}</span>
                                                                </TableHeaderWrap>
                                                            </TableCell>
                                                        ) : null
                                                    )}
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {lists?.map((eachList, index) => {
                                                    return (
                                                        <TableRow key={`${index}`}>
                                                            <TableCell sticky>
                                                                <div className="flex gap-[10px]">
                                                                    <div className="flex items-center gap-3">
                                                                        <div className="font-semibold text-[15px] leading-5">{moment(eachList?.date).format('DD-MMM-YYYY')}</div>
                                                                    </div>
                                                                </div>
                                                                {/* <div className={`${Style.tableActionArea} !gap-4`}>

                                                                    <div className={Style.tableActionAreaBtnGrpup}>
                                                                        <div
                                                                            className={
                                                                                "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                                                            }
                                                                            onClick={() => {
                                                                                editDetail(eachList);
                                                                            }}
                                                                        >
                                                                            <div
                                                                                className={Style.icon}
                                                                                style={{ color: "#FF9500" }}
                                                                            >
                                                                                <NewEditIcon className="h-4.5 w-4.5" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div> */}
                                                            </TableCell>

                                                            {tableHeaders?.map((eachHead, i) =>
                                                                eachHead.is_visible === 1 && eachHead?.show == 1 && !hiddenCols.includes(eachHead?.key) ? (
                                                                    <>
                                                                        {eachHead.key === "invoice_path" ? (
                                                                            <TableCell
                                                                                key={`${i}-${index}`}
                                                                                className={`text-center`}
                                                                            >
                                                                                <a href={`${eachList?.invoice_path}`} rel="noopener noreferrer" target="_blank">view</a>
                                                                            </TableCell>
                                                                        ) : (
                                                                            <TableCell key={`${i}-${index}`}>
                                                                                {(eachList[eachHead?.key]) ? (typeof eachList[eachHead?.key] == "string" && eachList[eachHead?.key]?.slice(0, 5) == "https") ? <Link to={eachList[eachHead?.key]} target="_blank" className="text-blue-600 underline">View</Link> : eachList[eachHead?.key] : "-"}
                                                                            </TableCell>
                                                                        )}
                                                                    </>
                                                                ) : null
                                                            )}
                                                        </TableRow>
                                                    );
                                                })}
                                            </TableBody>
                                        </Table>
                                    </TableCard>
                                </>
                            )}
                        </div>

                        {/* Footer */}
                        <div className="border-t border-solid border-slate-200 bg-white p-3 w-full">
                            <div className="flex items-center justify-between">
                                <span className="flex items-center gap-1 text-xs text-slate-500">
                                    <CalendarDays className="size-4" />
                                    <span>{data?.invoice_date}</span>
                                </span>
                            </div>
                        </div>

                    </motion.aside>
                </motion.div>
            )}
        </AnimatePresence>
    );
}